import BaseController from "controllers/backend/base"

import SelectVehicleTrimWidget from "widgets/select/selectVehicleTrimWidget"

class Controller extends BaseController {
  call() {
    super.call()
    bindVehicleTrimSelect.call(this)
  }
};

var bindVehicleTrimSelect = function() {
  let elem = this.root.find('form')
  this.vehicle_trims = new SelectVehicleTrimWidget(elem, {type: "new"})
  this.vehicle_trims.setState({selector: 'select#vehicle_vehicle_trim_id'})
}

export default Controller;
